/**
 * This component acts as a guard for authenticated routes.
 * It redirects unauthenticated users to the login page and ensures that
 * logged-in users have verified their email before accessing the main dashboard.
 */

import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase.js";
import DashBoard from "./dashboard";
import Header from "./header";
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";

export default function AuthenticateUser() {
  const navigate = useNavigate();
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (user === undefined) return;
    if (!user) {
      navigate("/");
    } else if (user.emailVerified === false) {
      navigate("/verify");
    }
  }, [user, navigate]);

  const logout = async () => {
    await signOut(auth);
    localStorage.removeItem("token");
    localStorage.removeItem("tab");
    navigate("/");
  };

  const profile = user?.email || "User";

  if (user === undefined) return null;
  return (
    <>
      <Header profile={profile} logout={logout} />
      <div style={{ justifyContent: "center", alignSelf: "center", alignItems: "center" }}> {/* Adjust this value based on your Header's actual height */}
        <DashBoard />
      </div>
    </>
  );
}
